module.exports = __webpack_public_path__ + "static/media/Schiratti1931-tagged.ab977bbe.jpg";